import { createFileRoute, redirect } from '@tanstack/react-router';

// DEC-007: The Branches drawer-tab was folded into the codebase settings
// page. Old bookmarks pointing at `/settings/sources/$sourceId/branches`
// land here — redirect them to the canonical Branches surface under
// `/cb/$codebaseId/settings/general` so admins reach the same content.
export const Route = createFileRoute('/$organizationName/settings/_access/sources/$sourceId/branches')({
  component: () => null,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$organizationName/cb/$codebaseId/settings/general',
      params: { organizationName: params.organizationName, codebaseId: params.sourceId },
    });
  },
});
